'use client';

import de from '@/locales/de.json';
import en from '@/locales/en.json';
import es from '@/locales/es.json';
import fr from '@/locales/fr.json';

export type Language = 'de' | 'en' | 'es' | 'fr';

export const SUPPORTED_LANGUAGES: { code: Language; label: string; flag: string }[] = [
  { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'es', label: 'Español', flag: '🇪🇸' },
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
];

const translations: Record<Language, typeof de> = { de, en, es, fr };

export function getTranslations(language: Language) {
  return translations[language] ?? translations['de'];
}

export const DEFAULT_LANGUAGE: Language = 'de';
